<div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title fw-bold">{{ getHeader(selectedDatasetType.label)}}</h4>
            <button type="button" class="btn-close" (click)="cancel()"></button>
        </div>
        <div class="modal-body">
            <div class="row mb-3">
                <div class="col-sm-6 pe-0">
                    <label class="form-label fw-bold"><span jhiTranslate="study-editor.subobservation-modal.dataset-name" [translateValues]="{param: selectedDatasetType.name}"></span><span
                            class="text-danger">*</span></label>
                </div>
                <div class="col-sm-6">
                    <input type="text" name="name" [(ngModel)]="datasetName" maxlength="100"
                           class="form-control" [disabled]="true"/>
                </div>
            </div>
            <div class="row mb-3">
                <div class="report-type-section col-12" style="height: 30px;">
                    <label class="form-label fw-bold">
                        {{ 'study-editor.subobservation-modal.choose.variable' | translate: {param: selectedDatasetType.alias} }}: <span class="text-danger">*</span></label>
                    <span class="fa-solid fa-circle-question help-icon ms-3"
                          [ngbTooltip]="selectedVariable?.description"></span>
                </div>
                <div class="report-type-section col-6-md col-md-6">
                    <select id="variableDatasetBuilder" name="selectVariableDatasetBuilder"
                            [(ngModel)]="selectedVariable"
                            class="form-select"  #variableField="ngModel" [disabled]="true" required>
                        <option *ngFor="let variable of variables" [ngValue]="variable">
                            {{variable.name}}
                        </option>
                        <option [ngValue]="null" jhiTranslate="global.please.choose">Please Choose</option>
                    </select>
                </div>
            </div>
            <div class="row mb-3" [ngClass]="{'has-error': isEmptySelection}">
                <div class="col-xs-12 col-md-12">
                    <label class="form-label fw-bold"><span jhiTranslate="study-editor.subobservation-modal.select.environments"
                        [translateValues]="{param:selectedDatasetType.name}"></span><span class="text-danger">*</span></label>
                </div>
                <div class="col-sm-12 pt-2">
                    <div class="text-danger" *ngIf="isEmptySelection">
                        <p jhiTranslate="study-editor.subobservation-modal.select.environments.error.empty">The environment(s) to which you would like to apply the sub-observations must be selected</p>
                    </div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-6"></div>
                <div class="col-6 d-flex justify-content-end">
                    <div class="btn-group">
                        <input type="text" class="form-control form-control-sm" placeholder="{{'search.placeholder' | translate}}" [(ngModel)]="searchQuery">
                        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="searchQuery = ''"><i
                                class="fa fa-times"></i></button>
                    </div>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col">
                    <div class="custom-scroll-style" style="max-height: 350px; overflow-y: auto; overflow-x: hidden;">
                        <table class="table table-striped table-bordered table-curved mb-0">
                            <thead class="sticky-header">
                            <tr>
                                <th class="text-center" style="border-top: 0; width: 30px;">
                                    <input type="checkbox" class="form-check-input m-2"
                                           [(ngModel)]="selectAll"
                                           (change)="doSelectAll()">
                                </th>
                                <th> {{ 'study-editor.study-dataset.instance-table-selector.trial-instance' | translate }}
                                </th>
                                <th> {{ 'study-editor.study-dataset.instance-table-selector.location-name' | translate }}
                                </th>
                                <th> {{ 'study-editor.study-dataset.instance-table-selector.no.of.units' | translate }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (instanceModel of studyInstanceItems | filter:searchQuery:'locationName'; track instanceModel.instanceId) {
                                    <tr>
                                        <td>
                                            <input type="checkbox" class="form-check-input m-1"
                                                   [(ngModel)]="instanceModel.isChecked"
                                                   (change)="instanceSelected()"
                                            >
                                        </td>
                                        <td>
                                            {{ instanceModel.instanceNumber }}
                                        </td>
                                        <td>
                                            {{ instanceModel.locationName }}
                                        </td>
                                        <td style="white-space: nowrap;">
                                            <input type="number" name="SubObservationUnits"
                                                   [(ngModel)]="instanceModel.numberOfSubObservationUnits"
                                                   [min]="1" [max]="maxSubObservationParentUnit"
                                                   class="form-control d-inline-block ms-1 w-75"
                                                   [required]="instanceModel.isChecked"
                                                   [disabled]="!instanceModel.isChecked"/>
                                            <i *ngIf="isNumberOfSubObsUnitDecreased(instanceModel)"
                                               class="fa fa-warning text-warning ms-2"
                                               [ngbTooltip]="'study-editor.study-dataset.instance-table-selector.decreased' | translate"></i>
                                        </td>
                                    </tr>
                                } @empty {
                                    <tr>
                                        <td colspan="4" class="text-center text-muted">
                                            <span> {{ 'study-editor.study-dataset.instance-table-selector.empty' | translate }}</span>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-hidden="true"
                        (click)="cancel()" jhiTranslate="back">Back</button>
                <button type="submit" class="btn btn-primary" (click)="submit()" [disabled]="isSaveDisabled()">
                    <span jhiTranslate="save">Save</span>
                    <span *ngIf="submitted" class="throbber-btn-wrapper">
                        <span class="throbber throbber-btn throbber-white"></span>
                    </span>
                </button>
            </div>
        </div>
    </div>


